import React from 'react';
import { useListContext, useDataProvider, useNotify, fetchRelatedRecords } from 'ra-core';
import { Button } from '@mui/material'; // Material-UIのButtonを直接使用
import DownloadIcon from '@mui/icons-material/GetApp';

export const CustomExportButton = (props) => {
  const {
    label,
    icon = <DownloadIcon fontSize="small" />, // アイコンをここで定義
    exporter,
    sx,
    ...rest
  } = props;

  const { filterValues, sort, resource } = useListContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [loading, setLoading] = React.useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      // フィルタリングされた全件を取得（maxResultsは適宜調整）
      const { data } = await dataProvider.getList(resource, {
        sort,
        filter: filterValues,
        pagination: { page: 1, perPage: 1000 },
      });
      // 渡されたexporter関数を実行
      exporter(
        data,
        fetchRelatedRecords(dataProvider),
        dataProvider,
        resource
      );
    } catch (error) {
      console.error(error);
      notify('ra.notification.http_error', { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handleClick}
      startIcon={icon}
      disabled={loading}
      size="small"
      sx={sx} // ListActionsから渡されたsxを適用
      {...rest}
    >
      {label}
    </Button>
  );
};